<template>
    <div >
        <portlet :clase="'container col-md-12'">
            <template slot="actions"> </template>
            <template slot="caption">
                <div class="row"> 
                <div class='col-md-6'>          
                    <span class="caption-subject bold uppercase"><i class="fa fa-search"></i> Filtros</span>          
                </div> 
                </div>  
            </template>
            <template slot="caption2">
                <div class="row">	
                    <div class="col-md-4 col-ms-12">
                    <div class="form-group">
                        <label >Rango de Fechas</label>
                        <v-date-picker v-model="range" is-range >
                            <template v-slot="{ inputValue, inputEvents }">
                                <div class="flex justify-center items-center input-group" >
                                <span class='input-group-addon'>De</span>
                                <input :value="inputValue.start" v-on="inputEvents.start" class="form-control  rounded border rounded"/>
                                <span class='input-group-addon'>A</span>
                                <input :value="inputValue.end" v-on="inputEvents.end" class="form-control  rounded border rounded green" />
                                </div>
                            </template>
                        </v-date-picker> 
                    </div>
                </div>	          
                <div class="col-md-7 col-ms-12">
                    <div class="form-group">
                    <label >Tipo Busqueda</label>
                    <select2 class="form-control" :options="options" v-model="tipo_busqueda">
                        <option :value="0" data-foo="North to the Future">---- Diferente de Archivos ----</option>
                        <option v-for="b in data_tipo" :value="b.documento"> {{b.documento}}</option>
                    </select2>
                    </div>
                </div>		            
                <div class="col-md-1 col-ms-12">
                    <div class="form-group">
                    <label>&nbsp;</label>
                    <button type="button" class="btn green enableBtn" id="btnbuscar" v-on:click="loadTableSample()" >Buscar</button>
                    </div>
                </div>            
                </div> 
            </template>
        </portlet>
      <portlet :clase="'container col-md-12 blockui_sample_3_2_element'" > 
        <template slot="actions"> 
          <!----<a class="btn btn-circle btn-icon-only btn-success" :href="link_download" data-toggle='modal' title='Descargar Excel' ><i class="fa fa-file-excel-o"></i></a>   -->     
        </template>
        <template slot="caption">
          <div class="row"> 
            <div class='col-md-6'>          
                <span class="caption-subject bold uppercase"> 
                    <i class="fa fa-database"></i> Cargar registros
                </span>         
            </div>
            <h5><div class='col-md-2'><span class="label label-primary btn-circle">&nbsp;&nbsp;</span>Actualizacion</div>
                <div class='col-md-2'><span class="label btn-warning btn-circle">&nbsp;&nbsp;</span>No actualizado</div>
                <div class='col-md-2'><span class="label btn-info btn-circle">&nbsp;&nbsp;</span>Nuevo registro</div> </h5>           
          </div>  
        </template>      
        <template slot="body">         
          <div class="row">           
            <tableSample :lengthMenu="lengthMenu" @guardar="detalleRegistros" :data_="data_" :id="'sample_2'" v-if="renderTable"/>  
          </div>
        </template>
      </portlet>
      <modal :id="'portlet-edit'" :modal="'modal-full'">      
        <template slot="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true" v-on:click="closeClear()"></button>
            <h4 class="modal-title"><i class="fa fa-cogs"></i> Padrón Licencia Alcoholes</h4>
        </template>
        <template slot="modal-body">
            <div class="row">
                <portlet :clase="'container col-md-6'" > 
                    <template slot="tools">
                        <a href="javascript:;" class="collapse"></a>
                    </template>
                    <template slot="caption">
                        <h4><strong>Registro Anterior</strong></h4>
                    </template>
                    <template slot="body" :style="'display: none;'">
                        <div class="row">
                            <div id="addDetalles" v-for="( d  , index ) in detalle_anterior">
                                <div v-if="index != 'id' && index != 'updated_at'" class='col-md-6'>
                                    <div class='form-group'>
                                        <label><strong>{{index.replaceAll("_", " ").toUpperCase()}}</strong></label>
                                        <br><label>{{d}}</label>
                                    </div>
                                </div>
                            </div>
                        </div>                            
                    </template>
                </portlet>
                <portlet :clase="'container col-md-6'" > 
                    <template slot="tools">
                        <a href="javascript:;" class="collapse"></a>
                    </template>
                    <template slot="caption">
                        <h4><strong>Registro Nuevo</strong></h4>
                    </template>
                    <template slot="body" :style="'display: none;'">
                        <div class="row">
                            <div id="addDetalles" v-for="( d  , index ) in detalle_">
                                <div v-if="index != 'id' && index != 'user_id' && index != 'json_registro'  && index != 'estatus_bitacora' && index != 'updated_at'" class='col-md-6'>
                                    <div class='form-group'>
                                        <label><strong>{{index.replaceAll("_", " ").toUpperCase()}}</strong></label>
                                        <br><label>{{ detalle_.estatus=='REFERENCIA ACTIVA' && index=='folio_de_pago' ? '' :  d}}</label>
                                    </div>
                                </div>
                            </div>
                        </div>                            
                    </template>
                </portlet> 
            </div>
        </template>
        <template slot="modal-footer">
          <button type="button" data-dismiss="modal" class="btn default">Cerrar</button>
        </template>
      </modal>
    </div>
  </template>  
  <script>
  import axios from 'axios'
  import select2 from './General/Select.vue'
  import portlet from './General/Portlet.vue'
  import modal from './General/Modal.vue'
  import modalconfirmation from './General/ModalConfirmation.vue'
  import tableSample from './General/TableSampleBitacora.vue'
  import VCalendar from 'v-calendar'
  export default {
    name: 'ReporteEstadistica',
    components: {axios,select2,portlet,modal,modalconfirmation,tableSample,VCalendar},
    data(){
        return{
            tipo_busqueda:'0',
            options:[],
            data_tipo:[],
            data_:[],
            detalle_:[],
            detalle_anterior:[],
            range: {
                start:this.firtsDate(),
                end: new Date(),
            },
            lengthMenu:[],
            id_registro:'',
            renderTable:false,
            link_download:`${process.env.APP_URL}/download-alcoholes-bitacora` ,
        }
    },
    methods:{
        loadTableSample(){
            this.renderTable=false;
            this.loagingC(true);
            this.data_=[];                  
            axios.post(`${process.env.APP_URL}/search-bitacora-alcoholes`,{
                incio: new Date(this.range.start).toISOString().slice(0,10),
                fin: new Date(this.range.end).toISOString().slice(0,10),
                tipo_busqueda:this.tipo_busqueda})
                .then((response)=>{                     
                    this.data_=response.data.response; 
                    this.loagingC(false);
                    this.renderTable=true;
                })
                .catch(error=>{
                    console.log(error);                    
                    this.loagingC(false);                    
                }
            );               
        },
        listaArchivos(){
            this.data_tipo=[];                  
            axios.get(`${process.env.APP_URL}/listar-archivos-alcoholes`)
                .then((response)=>{
                    this.data_tipo=response.data.response;
                })
                .catch(error=>{
                    console.log(error);                   
                }
            );               
        },
        detalleRegistros(dato){
            this.detalle_=dato;
            let anterior=JSON.parse(dato.json_registro);
            if(dato.json_registro!=null){
                this.detalle_anterior=anterior[0];
            }else{
                this.detalle_anterior=[];
            }
        },
        downloadFile(){           
            axios.get(`${process.env.APP_URL}/download-alcoholes`)
                .then((response)=>{           
            
                })
                .catch(error=>{
                    this.notifications("400","Error al descargar");
                    console.log(error);
                }
            );
        },
        firtsDate(){
            var date = new Date();
            var primerDia = new Date(date.getFullYear(), date.getMonth(), 1);
            return primerDia
        },
        fmoneda(value, tipo, values) {
            return Vue.filter('chartTick')(value,tipo);
        },
        loagingC(value, index, values) {
            return Vue.filter('loadingCharge')(value);
        },
        notifications(Code,Message){
            if(Code=="200"){
                Command: toastr.success(Message, "Notifications");
            }else{
                Command: toastr.warning(Message, "Notifications");
            }
        }
    },
    mounted() {
        this.listaArchivos();
        this.loadTableSample();
        
    } 
  }
  </script>